const plan_list = {
  title: 'プラン管理',
  new: '追加',
  search_plan_placeholder: '検索',
  id: '順番',
  name: 'プラン名',
  price: '金額',
  max_student: '受講生追加できる人数',
  created_date: '作成日',
  toast: {
    public_plan_success: 'ご指定のプランを公開しました。',
    save_draft_plan_success: 'ご指定のプランを非公開しました。',
  },
  modal: {
    change_status_draft_to_public: {
      title: 'プラン非公開の確認',
      content: 'ご指定のプランを公開すると、登録フォームに表示します。よろしいでしょうか。',
      cancel: 'いいえ',
      yes: 'はい',
    },
    change_status_public_to_draft: {
      title: 'プラン公開の確認',
      content: 'ご指定のプランを非公開すると、登録フォームに表示しません。よろしいでしょうか。',
      cancel: ' いいえ',
      yes: 'はい',
    },
  },
}

export default plan_list;